import { memo, useMemo } from 'react'
import { useSubfilterActions, useTranslations } from 'hooks'

import PropTypes from 'prop-types'
import { Slider } from 'antd'
import { StyledCollapse } from 'components/views/Filter/Filter.styled'

const DestinationFilter = (props) => {
  const { setFilterParams, filterParams, setSearchRadius, searchRadius } = props
  const { t } = useTranslations()

  const subfilterOptions = useMemo(
    () => ({
      filterParams,
      setFilterParams,
      fieldName: 'address.location',
      operand: 'slider'
    }),
    [filterParams, setFilterParams]
  )

  const { onChange } = useSubfilterActions(subfilterOptions)
  const handleSliderChange = (value) => {
    setSearchRadius(value * 1000)
    onChange(value * 1000)
  }

  const marks = {
    1: 1,
    50: 50,
    100: 100
  }
  return (
    <StyledCollapse ghost defaultActiveKey="price">
      <StyledCollapse.Panel
        header={t('Destination, km')}
        key="price"
        forceRender>
        <div className="mx-4">
          <Slider
            min={1}
            max={100}
            step={1}
            value={searchRadius / 1000}
            onChange={handleSliderChange}
            marks={marks}
          />
        </div>
      </StyledCollapse.Panel>
    </StyledCollapse>
  )
}
DestinationFilter.propTypes = {
  filterParams: PropTypes.object,
  setFilterParams: PropTypes.func,
  setSearchRadius: PropTypes.func,
  searchRadius: PropTypes.number
}

export default memo(DestinationFilter)
